<template>
    <div class="newsSecondPage2">
        <div class="newsbox" v-if="dataList.length!==0">
            <div class="leftImgRightTextBox">
                <div v-for="(item,index) in dataList" :key="index" class="itemBox" @click="goNewsDetailFn(item)">
                    <img :src="srcUrl+item.titleImgUrl" class="imgbox" />
                    <div class="contentbox">
                        <div class="title overflowone">{{item.pressTopic}}</div>
                        <div class="synopsis overflowtwo">{{item.synopsis}}</div>
                        <div class="time">{{item.pressTime | timer}}</div>
                    </div>
                </div>
            </div>
            <div class="pagination-box">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                    :page-sizes="[8, 10, 12,16]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>
        <div class="emptyBox" v-else>
            <img src="@/assets/imgs/home/emptyimg.png" />
        </div>
    </div>
</template>
<script>
import { httpService, srcUrl } from "@/service/httpService";
export default {
    components: {
    },
    data() {
        return {
            srcUrl: srcUrl,
            currentPage: 1,
            total: null,
            pageSize: 8,
            dataList: []

        }
    },
    watch: {
        $route: {
            handler: function (val, oldVal) {
                let currentNew = JSON.parse(sessionStorage.getItem('currentNew'))
                if (currentNew) {
                    if (currentNew.currentPage) {
                        this.currentPage = currentNew.currentPage * 1;
                        // this.getNews();
                    }
                    if (currentNew.site) {
                        document.body.scrollTop = currentNew.site
                    }
                }
                sessionStorage.removeItem('currentNew')
            },
            deep: true,
            immediate: true,
        },
    },
    mounted() {
        this.getNews()
    },
    methods: {
        async getNews() {
            let params = {
                pageSize: this.pageSize,
                pageCurrent: this.currentPage,
                pressSuperClass: 8,
            };
            let data = await httpService.getNewsList(params);
            if (data.code == 200) {
                this.dataList = data.result.list
                this.total = data.result.total;
            }
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.getNews();
        },
        handleCurrentChange(val) {
            // this.pageSize = 1;
            this.currentPage = val;
            this.getNews();
        },
        goNewsDetailFn(val) {
            let currentNew = {
                menuurl: '/tarin-secondpage/tarin-inform',
                currentPage: this.currentPage,
                site: window.scrollY,
                title: '培训通知'
            }
            sessionStorage.setItem('currentNew', JSON.stringify(currentNew))
            this.$router.push({
                path: "/news-detail",
                query: {
                    id: val.pressId,
                },
            });
        }

    },
    filters: {
        timer: (value) => {
            return value.substring(0, 10);
        },
    },
}
</script>
<style lang="less" scoped>
.newsSecondPage2 {
	width: 1200px;
	padding-bottom: 20px;
	.newsbox {
		// max-height: 860px;
		min-height: 660px;
		position: relative;
		.pagination-box {
			position: absolute;
			bottom: -60px;
			left: 50%;
			transform: translateX(-50%);
		}
		.leftImgRightTextBox {
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			.itemBox {
				display: flex;
				flex-direction: row;
				margin: 0 48px 50px 0;
				width: 48%;
				cursor: pointer;
				&:nth-child(2n) {
					margin-right: 0;
				}
			}
		}
	}
}
</style>


